<template>

    <div class="container">
        
        <app-head name="Campaigns" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Campaigns') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.campaigns.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="Status" v-model="form.status">
                    <option :value="null">{{ __('Veröffentlicht') }}</option>
                    <option value="trashed">{{ __('Papierkorb') }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="campaigns.meta" />
        </div>

        <div class="card">
            <data-table :items="campaigns.data"
                        :links="campaigns.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="campaign in campaigns.data" :key="campaign.id">
                    <td>
                        {{ campaign.id }}
                    </td>
                    <td>
                        <inertia-link class=" stretched-link" :href="route('admin.campaigns.edit', campaign)">
                            {{ campaign.name }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ campaign.description | truncateWords }}
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';
    
    import Results from '@/shared/Admin/Results';

    export default {
        props: {
            filters: Object,
            campaigns: Object,
        },
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    name: {label: 'Title', sortable: 'name'},
                    description: {label: 'Description'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.campaigns.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>